import { gql } from "@shared/utils";
const DYNAMIC_VARIABLE_INNER = `
  _id
  variableType
  number
  text
  operator
  categoryId
  subcategoryId
  subcategoryValueId
  optionId
  Option {
    name
  }
  subtype
  output
  unit
`;

const OPTION_LIST_QUERY = `
OptionsList {
  variableType
  number
  text
  unit
  subcategory
  SubCategory {
    name
    maxOptions
    sortOrder
    _id
    Category {
      name
      _id
    }
    Options {
      name
      _id
      sortOrder
      variableType
      number
      text
      unit
      validators {
        id
        input
        Input {
          ${DYNAMIC_VARIABLE_INNER}
        }
        comparator
        output
        Output {
          ${DYNAMIC_VARIABLE_INNER}
        }
      }
      AllowList {
        subcategory
        options
      }
    }
  }
  options
}
`;

const CATEGORY_QUERY = `Categories {
  _id
  product
  name
  dynamicName
  quantity
  eachLength
  quantityAdvanced
  eachLengthAdvanced
  parentProductCategory
  useParentValues
  soldIn
  DynamicName {
    ${DYNAMIC_VARIABLE_INNER}
  }
  Quantity {
    ${DYNAMIC_VARIABLE_INNER}
  }
  EachLength {
    ${DYNAMIC_VARIABLE_INNER}
  }
  SubCategorys {
    _id
    category
  }
  CategoryQuantities {
    _id
    name
    categoryId
    quantity
    Quantity {
      ${DYNAMIC_VARIABLE_INNER}
    }
    validators {
      id
      unit
      input
      Input {
        ${DYNAMIC_VARIABLE_INNER}
      }
      comparator
      output
      Output {
        ${DYNAMIC_VARIABLE_INNER}
      }
    }
  }
 }`;

const PRODUCT_FEATURE_QUERY = `
  productFeatures
  ProductFeatures {
      _id
      name
      productId
      categoryIds
      incompatibleCategoryIds
      description
      createdDate
      displayOrder
      isActive
  }
`;

export const PRODUCT_CONFIGURATION_VIEW_INNER = `
  _id
  product
  ParentProductConfiguration {
    ${OPTION_LIST_QUERY}
  }
   ${CATEGORY_QUERY}
   ${OPTION_LIST_QUERY}
   ${PRODUCT_FEATURE_QUERY}
`;

export const PRODUCT_CONFIGURATION_VIEW_QUERY = gql`
  query FixedProductConfiguration($id: ID!) {
    productConfiguration(id: $id) {
      ${PRODUCT_CONFIGURATION_VIEW_INNER}
    }
  }
`;
export const CATEGORY_SEARCH = gql`
  query Categorys($product: String) {
    categorys(product: $product) {
      _id
      name
      parentProductCategory
      useParentValues
      SubCategorys {
        name
        _id
        sortOrder
        Options {
          name
          _id
          sortOrder
          variableType
          AllowList {
            subcategory
            options
          }
          validators {
            id
            input
            Input {
              ${DYNAMIC_VARIABLE_INNER}
            }
            comparator
            output
            Output {
              ${DYNAMIC_VARIABLE_INNER}
            }
          }
        }
      }
      Options {
        name
        _id
        sortOrder
        variableType
        AllowList {
          subcategory
          options
        }
      }
      requiredCategorys
      incompatibleCategorys
      ParentCategory {
        _id
        name
        parentProductCategory
        useParentValues
        SubCategorys {
          name
          _id
          sortOrder
          Options {
            name
            _id
            sortOrder
            variableType
            AllowList {
              subcategory
              options
            }
          }
        }
        Options {
          name
          _id
          sortOrder
          variableType
          AllowList {
            subcategory
            options
          }
        }
        requiredCategorys
        incompatibleCategorys
      }
    }
  }
`;
